var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderC2C({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2012 12.1682V6.50586H3.92969V17.8306H12.0654",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8941 12.8565C16.956 12.8208 17.0323 12.8208 17.0941 12.8565L20.1181 14.6024C20.18 14.6381 20.2181 14.7041 20.2181 14.7756V18.2674C20.2181 18.3388 20.18 18.4049 20.1181 18.4406L17.0941 20.1865C17.0323 20.2222 16.956 20.2222 16.8941 20.1865L13.8702 18.4406C13.8083 18.4049 13.7702 18.3388 13.7702 18.2674V14.7756C13.7702 14.7041 13.8083 14.6381 13.8702 14.6024L16.8941 12.8565Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92969 9.90039L20.2012 9.90039",
    stroke: "currentColor",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderC2C);
export default __webpack_public_path__ + "static/media/header-c2c.c61349f0a9f13bb42dc807d9f03758aa.svg";
export { ForwardRef as ReactComponent };